import { App, Flex } from 'antd'
import { PropsWithChildren } from 'react'
import { Profile } from '../../components/profile/Profile'
import { Link } from 'react-router-dom'

const OnboardingInstagram = ({ children }: PropsWithChildren) => {
  return (
    <Flex vertical>
      <Flex
        style={{
          width: '100%',
          height: 64,
          padding: 20,
        }}
        align="center"
        justify="space-between"
      >
        <Link to={'/'}>
          <img src="/assets/images/logos/regular/purple.png" height={45} />
        </Link>
      </Flex>
      <Flex
        style={{
          width: '100%',
          height: 'calc(100vh - 64px)',
          overflow: 'scroll',
          padding: 20,
        }}
      >
        <Profile.ConnectFlow onCreated={() => {}} />
      </Flex>
    </Flex>
  )
}

export default OnboardingInstagram
